mutation PurchaseOrderUrgentUpdate($input: PurchaseOrderUrgentUpdateInput!) {
  purchaseOrderUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
